// extracted by mini-css-extract-plugin
module.exports = {"title":"ShowOrgLevelTaskSopsPage_title__3vYcA","description":"ShowOrgLevelTaskSopsPage_description__19tUp","taskType":"ShowOrgLevelTaskSopsPage_taskType__30JT4"};